<div class="fdx-o-grid__row fdx-o-grid__row--center fdx-u-mb--10 fdx-u-mt--10">
  <ng-content></ng-content>
</div>
